module.exports = __webpack_public_path__ + "img/staff-5.1023dae1.png";